module.exports = __webpack_public_path__ + "img/first-day-3.59917e28.webp";